import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ExerciseRequestDto } from '../../types/exercise-request.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useExerciseRequest = ({ companyId }: { companyId: string }) => {
  const { invalidateQueries } = useQueryClient();
  const { mutate: exerciseRequest } = useAppMutation(
    [QueryKey.NOTIFICATION_EXERCISE_REQUEST, companyId],
    {
      mutationFn: ({
        exerciseRequestId,
        ...dto
      }: { exerciseRequestId: string } & ExerciseRequestDto) =>
        ApiService.post(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'exercise-request', exerciseRequestId],
          },
          { body: dto },
        ),
      onSuccess: () => {
        invalidateQueries({ queryKey: [QueryKey.NOTIFICATION_EXERCISE_REQUEST] });
        invalidateQueries({ queryKey: [QueryKey.GET_NOTIFICATIONS] });
      },
    },
  );

  return {
    exerciseRequest,
  };
};
